import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import _ from 'lodash';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';

//Services
import { EmployeeInfoService } from '../../../core/services/employee-info.service';
import { EventService } from '../../../core/services/event.service';
import { PortalSettingsService } from '../../../core/services/portal-settings.service';
import { UtilityService } from '../../../core/services/utility.service';
import { ApprovalService } from '../../../pages/approval/services/approval.service';
import { ReviewTimecardService } from '../../../pages/approval/services/review-timecard.service';
import { CrewTimecardService } from '../../../pages/crew-timecard/services/crew-timecard.service';
import { TimecardService } from '../../../pages/timecard/services/timecard.service';
import { TimeParserService } from '../../../core/services/time-parser.service';
import { EmployeeService } from '../../../pages/employee/services/employee.service';

//Modals
import { TimeWorkedDetailsModalComponent } from '../../../modals/approval/TimecardApproval/time-worked-details-modal/time-worked-details-modal.component';
import { AddTimecardAttachmentModalComponent } from '../../../modals/timecard/add-timecard-attachment-modal/add-timecard-attachment-modal.component';
import { TimeWorkedNotesModalComponent } from '../../../modals/timecard/time-worked-notes-modal/time-worked-notes-modal.component';

@Component({
  selector: 'app-timecard-review-grid',
  templateUrl: './timecard-review-grid.component.html',
  styleUrls: ['./timecard-review-grid.component.css'],
})
export class TimecardReviewGridComponent implements OnInit {
  @ViewChild('mapDiv') mapDiv: ElementRef;
  @ViewChild('signaturePad', { static: false }) signaturePad: any;
  @Output() loadSummary = new EventEmitter<any>();
  @Output() approveTimecardEvent = new EventEmitter<any>();
  @Output() rejectTimecardEvent = new EventEmitter<any>();
  @Output() cancel = new EventEmitter<any>();
  @Output() updateDayRoute = new EventEmitter<any>();
  @Output() submitTimecard = new EventEmitter<any>();
  @Output() updateWeekOfDay = new EventEmitter<any>();

  portalSettings: any;
  employeeInfo: any;
  standardSettings: any = {};
  crewSettings: any = {};
  map: google.maps.Map;
  reviewGrid: any = {};
  selectedDay: any = {};
  selectedWeek: any = {};
  selectedPayPeriod: any = {};
  dailySummary: any = {};
  timecard: any = {};
  rawRows: any = {};
  columnsByLineType: any = {};
  crewTemplateList: any[] = [];
  timeWorkedSubTotals: any = [];
  weeks: any[] = [];
  timeWorked: any[] = [];
  mapPoints: any[] = [];
  filteredPoints: any[] = [];
  jobPoints: any[] = [];
  dailyTimeData: any[] = [];
  daysOfWeek: any[] = [];
  originalTimeWorked: any[] = [];
  timecardTotals: any[] = [];
  otherTotals: any[] = [];
  timecardReview = false;
  showMap = false;
  facialRecEnabled = false;
  facialRecThreshold = false;
  isUSCountryCode = false;
  reviewAll = false;
  reviewLocationCollapsed = false;
  reviewDailyCollapsed = false;
  reviewGridLoading = false;
  dailyTimeLoaded = false;
  reviewOnly = false;
  isStandardTimecard = false;
  requireSign = false;
  showClickMsg = false;
  signatureNEmpty = false;
  enableCheckboxSign = false;
  hideClick = false;
  redBorder = false;
  typeSign = false;
  showBreakHours = false;
  mobileMode = false;
  hasTime: boolean[];
  submissionValidationMsg: string;
  placesHolderMsg: string;
  currencySymbol: string;
  unbilledLabel: string;
  greenMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/green-dot.png';
  yellowMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/yellow-dot.png';
  redMarker = 'https://www.google.com/intl/en_us/mapfiles/ms/micons/red-dot.png';
  saveDateFormat = 'MM/DD/YYYY h:mm:ss a';
  action = 'approve';
  gpsClockInFaultTolerance: number;
  panelWidth = 530;
  pREHKeyID: any;
  submitSignImg: any;
  rawImgData: any;
  alert: { [key: string]: any } = null;
  dateFormat: string;
  signaturePadOptions: Object = {
    canvasWidth: 495,
    canvasHeight: 150,
  };

  constructor(
    private ngbModal: NgbModal,
    private portalSettingsService: PortalSettingsService,
    private employeeInfoService: EmployeeInfoService,
    private utilityService: UtilityService,
    private approvalService: ApprovalService,
    private crewTimecardService: CrewTimecardService,
    private timecardService: TimecardService,
    private reviewTimecardService: ReviewTimecardService,
    private eventService: EventService,
    private sharedModalService: BsModalService,
    private employeeService: EmployeeService,
    private timeParserService: TimeParserService
  ) {
    this.portalSettings = portalSettingsService.getPortalSettings();
    this.employeeInfo = employeeInfoService.getEmployeeInfo();
    this.currencySymbol = this.utilityService.getCurrencySymbol(this.employeeInfo.PRCo);
    this.mobileMode = utilityService.isMobileMode();
    this.dateFormat = utilityService.getDateFormat().toUpperCase();
  }

  ngOnInit(): void {
    this.showMap = this.portalSettings.EnableGPSValidation.ConfigValue == '1';
    this.facialRecEnabled = this.portalSettings.TCFacialRecEnabled.ConfigValue == '1';
    this.facialRecThreshold = this.portalSettings.TCFacialRecThreshold.ConfigValue;
    this.isUSCountryCode = this.portalSettings.CountryDateCode.ConfigValue == 'US';
    this.gpsClockInFaultTolerance = parseInt(this.portalSettings.GPSClockInFaultTolerance.ConfigValue || 0) / 60;
    this.unbilledLabel =
      this.portalSettings.UnbilledJobLineLabel.ConfigValue == ''
        ? 'Unbilled Job Hours'
        : this.portalSettings.UnbilledJobLineLabel.ConfigValue;
    this.requireSign = this.portalSettings.RequireSigOnSubmit.ConfigValue == '1';
    this.submissionValidationMsg = this.portalSettings.TCSubmitVerifyLang.ConfigValue;
    this.enableCheckboxSign = this.portalSettings.EnableCheckboxSign.ConfigValue == '1';
    this.placesHolderMsg = this.portalSettings.TimecardReviewMsg.ConfigValue;
  }

  setTimecard(timecard: any) {
    this.timecard = timecard;
  }

  setTimecardTotals(totalTimecard: any, otherTotals: any) {
    this.timecardTotals = totalTimecard;
    this.otherTotals = otherTotals;
    if (this.isStandardTimecard) {
      this.calculateSubtotalsForStandard();
    } else {
      this.calculateSubtotalsForApproval();
    }
  }

  collapseReviewLocation() {
    this.reviewLocationCollapsed = !this.reviewLocationCollapsed;
    if (this.reviewLocationCollapsed != true) {
      setTimeout(() => {
        google.maps.event.trigger(this.map, 'resize');
      });
    }
  }

  reviewTimecard(timecard: any, reviewAll: boolean) {
    this.crewTemplateList = [];
    this.reviewAll = reviewAll;
    if (this.reviewAll) {
      timecard.forEach((val: any) => {
        if (val.DateApproved == null && val.ShowApprovalButton) {
          this.crewTemplateList.push(val.CrewTemplateID != null ? val.CrewTemplateID : null);
        }
      });
      timecard = timecard[0];
    }
    this.reviewGrid = {};
    this.timecardReview = true;
    this.reviewLocationCollapsed = true;
    this.reviewDailyCollapsed = false;
    this.reviewGridLoading = true;
    let rawRows = null;
    let columnsByLineType = null;
    let crewTemplateID = null;
    let reviewAllTemp = null;
    if (this.isStandardTimecard) {
      rawRows = this.rawRows;
      columnsByLineType = this.columnsByLineType;
      this.dailyTimeLoaded = true;
    } else {
      crewTemplateID = timecard.CrewTemplateID;
      reviewAllTemp = this.reviewAll;
      this.weeks = null;
      this.selectedWeek = null;
      this.selectedDay = null;
      this.timeWorkedSubTotals = [];
      this.timeWorked = [];
      this.dailySummary = null;
    }
    this.reviewTimecardService
      .getReviewGrid(
        timecard.PREHKeyID,
        timecard.HQBCKeyID,
        this.action,
        rawRows,
        columnsByLineType,
        timecard.TimecardPersistID,
        timecard.IsSubmitted,
        this.portalSettings,
        crewTemplateID,
        reviewAllTemp,
        this.currencySymbol
      )
      .then((response: any) => {
        if (response != null) {
          this.reviewGrid = response;
          this.reviewGrid.timecard = timecard;
          this.reviewGridLoading = false;
          if (!this.isStandardTimecard) {
            if (
              (this.reviewGrid.timecard.CrewTemplateID !== null && this.crewSettings.IsTimeWorkedEnabled) ||
              (this.reviewGrid.timecard.CrewTemplateID === null && this.standardSettings.IsTimeWorkedEnabled)
            ) {
              this.getWeeks();
            }
            this.calculateDailySummary();
          }
        }
        if (this.showMap) {
          this.mapPoints = this.filteredPoints = [];

          this.timecardService.getPointsByTimecardPersistID(timecard.TimecardPersistID).then((mapPointResponse: any) => {
            if (mapPointResponse != null) {
              mapPointResponse.forEach((point: any) => {
                const date = moment.utc(point.ClockTime);
                point.DisplayTime = date.format(this.dateFormat);
                point.DisplayDate = date.format(this.dateFormat);
              });

              this.mapPoints = this.filteredPoints = mapPointResponse;
              if (this.mapPoints.length > 0) {
                this.jobPoints = [];
                this.timecardService.getJobLocationPoints(timecard.TimecardPersistID).then((jobLocationPoints: any) => {
                  if (jobLocationPoints != null) {
                    this.jobPoints = jobLocationPoints;
                    setTimeout(() => {
                      this.map = new google.maps.Map(this.mapDiv?.nativeElement, { zoom: 8 });
                      this.mapAllPoints();
                    });
                  }
                });
              }
            }
          });
        }
      });
  }

  mapSinglePoint(point: any) {
    if (point.GPSLat == null || point.GPSLong == null) {
      return;
    }
    this.map = new google.maps.Map(this.mapDiv?.nativeElement, { zoom: 8 });
    const bounds = new google.maps.LatLngBounds();
    let marker;
    if (point.ClockAction) {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(point.GPSLat), parseFloat(point.GPSLong)),
        map: this.map,
        icon: this.greenMarker,
      });
    } else {
      marker = new google.maps.Marker({
        position: new google.maps.LatLng(parseFloat(point.GPSLat), parseFloat(point.GPSLong)),
        map: this.map,
        icon: this.redMarker,
      });
    }
    bounds.extend(marker.getPosition());
    this.map.fitBounds(bounds);
  }

  mapAllPoints() {
    const bounds = new google.maps.LatLngBounds();
    let pointsToBind = this.jobPoints.length;
    this.filteredPoints = this.mapPoints;

    this.jobPoints.forEach((job: any) => {
      let address = job.JobAddress;
      if (job.JobAddress2 != null) {
        address += ' ' + job.JobAddress2;
      }
      address += ', ' + job.JobCity + ', ' + job.JobState;
      if (job.JobZip != null) {
        address += ' ' + job.JobZip;
      }
      this.timecardService.getMapCoordinates(encodeURIComponent(address)).then(
        (response: any) => {
          if (response != null) {
            const marker = new google.maps.Marker({
              position: new google.maps.LatLng(response.Latitude, response.Longitude),
              map: this.map,
              icon: this.yellowMarker,
            });
            bounds.extend(marker.getPosition());
            pointsToBind--;
            if (pointsToBind == 0) {
              this.map.fitBounds(bounds);
            }
          }
        },
        error => {
          pointsToBind--;
          if (pointsToBind == 0) {
            this.map.fitBounds(bounds);
          }
        }
      );
    });

    this.mapPoints.forEach((mapPoint: any) => {
      if (mapPoint.GPSLat != null && mapPoint.GPSLong != null) {
        let marker;
        if (mapPoint.ClockAction) {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(mapPoint.GPSLat), parseFloat(mapPoint.GPSLong)),
            map: this.map,
            icon: this.greenMarker,
          });
        } else {
          marker = new google.maps.Marker({
            position: new google.maps.LatLng(parseFloat(mapPoint.GPSLat), parseFloat(mapPoint.GPSLong)),
            map: this.map,
            icon: this.redMarker,
          });
        }
        bounds.extend(marker.getPosition());
      }
    });

    if (pointsToBind == 0) {
      this.map.fitBounds(bounds);
    }
  }

  //Daily Summary
  private calculateDailySummary() {
    //ignore any timecard rows using earncodes set to be exluded
    const dailySummary = { Total: { J: 0, S: 0, M: 0, O: 0, Total: 0, Expenses: 0 } };
    if (this.reviewGrid.rows != null) {
      Object.entries(this.reviewGrid.rows).forEach(([lineType, rowsByType]) => {
        if (Array.isArray(rowsByType)) {
          rowsByType.forEach((row: any) => {
            if (row.PostDate != null) {
              if (dailySummary[row.PostDate] == null) {
                dailySummary[row.PostDate] = {
                  J: 0,
                  S: 0,
                  M: 0,
                  O: 0,
                  Expenses: 0,
                  Total: 0,
                  Date: row.PostDate,
                  DisplayDate: row.PostDate,
                };
              }
              const hours = parseFloat(row.Hours);
              if (!isNaN(hours)) {
                if (row.IsAmountRow) {
                  dailySummary[row.PostDate].Expenses += hours;
                  dailySummary.Total.Expenses += hours;
                } else {
                  dailySummary[row.PostDate][lineType] += hours;
                  dailySummary[row.PostDate].Total += hours;
                  dailySummary.Total[lineType] += hours;
                  dailySummary.Total.Total += hours;
                }
              }
            }
          });
        }
      });
    }
    this.dailySummary = dailySummary;
  }

  private getWeeks() {
    this.weeks = [];
    this.timecardService.getWeeksByPRPCKeyID(this.selectedPayPeriod.PRPCKeyID).then((response: any) => {
      if (response != null) {
        this.weeks = response;
        const smallDateFormat = this.isUSCountryCode ? 'MM/DD' : 'DD/MM';
        this.weeks.forEach((week: any) => {
          const startDate = moment.utc(week.WeekBeginDate);
          const startDateDisplay = startDate.format(smallDateFormat);
          const endDate = moment.utc(week.WeekEndDate);
          const endDateDisplay = endDate.format(smallDateFormat);
          const displayValue = 'Week of: ' + startDateDisplay + ' - ' + endDateDisplay;
          week.StartDate = startDate;
          week.EndDate = endDate;
          week.DisplayValue = displayValue;
        });
        this.selectedWeek = this.weeks.length > 0 ? this.weeks[0] : null;
        if (this.selectedWeek != null) {
          this.getDailyTime();
        }
      }
    });
  }

  dayChanged() {
    if (this.isStandardTimecard) {
      this.updateDayRoute.emit(this.selectedDay);
    }
  }

  getDailyTime() {
    this.dailyTimeLoaded = false;
    this.dailyTimeData = [];
    this.selectedDay = null;
    this.timecardService
      .getDailyTime(
        this.reviewGrid?.timecard.PREHKeyID,
        null,
        this.selectedPayPeriod?.PRPCKeyID,
        this.selectedWeek?.StartDate.format('MM/DD/YYYY'),
        this.selectedWeek?.EndDate.format('MM/DD/YYYY')
      )
      .then((response: any) => {
        if (response != null) {
          response.forEach((dailyTime: any) => {
            dailyTime.Date = moment.utc(dailyTime.Date);
            if (dailyTime.StartTime != null) {
              dailyTime.StartTime = moment.utc(dailyTime.StartTime).format('hh:mm A');
            }
            if (dailyTime.StopTime != null) {
              dailyTime.StopTime = moment.utc(dailyTime.StopTime).format('hh:mm A');
            }
            dailyTime.DayOfWeek = dailyTime.Date.day();
          });
          this.dailyTimeData = response;
          this.groupDailyTime();
        }
      });
  }

  private groupDailyTime() {
    this.daysOfWeek = [];
    for (let i = 0; i < 7; i++) {
      const dayOfWeek = new Date(
        this.selectedWeek.StartDate.year(),
        this.selectedWeek.StartDate.month(),
        this.selectedWeek.StartDate.date()
      );
      dayOfWeek.setDate(dayOfWeek.getDate() + i);
      let day;
      const dayNumber = dayOfWeek.getDay();
      switch (dayNumber) {
        case 0:
          day = 'Sun';
          break;
        case 1:
          day = 'Mon';
          break;
        case 2:
          day = 'Tues';
          break;
        case 3:
          day = 'Wed';
          break;
        case 4:
          day = 'Thurs';
          break;
        case 5:
          day = 'Fri';
          break;
        case 6:
          day = 'Sat';
          break;
      }

      if (this.isUSCountryCode) {
        day = day + ' ' + (dayOfWeek.getMonth() + 1) + '/' + dayOfWeek.getDate();
      } else {
        day = day + ' ' + dayOfWeek.getDate() + '/' + (dayOfWeek.getMonth() + 1);
      }
      //Todo: Need to check dayOfWeek / 1
      this.daysOfWeek.push({ Date: dayOfWeek, Day: day, DayNumber: dayNumber, DateValue: dayOfWeek });
    }
    if (this.isStandardTimecard) {
      this.updateWeekOfDay.emit(this.daysOfWeek);
    }
    if (this.selectedDay == null) {
      this.selectedDay = this.daysOfWeek.length > 0 ? this.daysOfWeek[0] : null;
    } else {
      this.selectedDay = this.daysOfWeek.find((day: any) => day.DateValue == this.selectedDay.DateValue);
    }
    this.timeWorked = [];
    this.dailyTimeData.forEach((dailyTime: any) => {
      if (this.timeWorked[dailyTime.Seq - 1] == null) {
        this.timeWorked[dailyTime.Seq - 1] = [];
      }
      this.timeWorked[dailyTime.Seq - 1][dailyTime.DayOfWeek] = dailyTime;
    });

    this.timeWorked.forEach((workedValue: any, workedKey: any) => {
      if (workedValue == null) {
        workedValue = [];
      }
      this.daysOfWeek.forEach((weekValue: any, weekKey: any) => {
        if (this.timeWorked[workedKey][weekKey] == null) {
          this.timeWorked[workedKey][weekKey] = {
            Date: weekValue.Date,
            DayOfWeek: weekValue.DayNumber,
          };
        }
      });
    });

    if (this.timeWorked.length == 0) {
      this.timeWorked[0] = [];
      this.daysOfWeek.forEach((weekValue: any, weekKey: any) => {
        this.timeWorked[0][weekKey] = {
          Date: weekValue.Date,
          DayOfWeek: weekValue.DayNumber,
        };
      });
    }

    this.originalTimeWorked = _.cloneDeep(this.timeWorked);
    this.dailyTimeLoaded = true;
    if (this.isStandardTimecard) {
      this.updateHasTime();
      this.calculateSubtotalsForStandard();
    } else {
      this.calculateSubtotalsForApproval();
    }
  }

  //keeps track of which time entry columns have time
  private updateHasTime() {
    const hasTime = [];
    this.timeWorked.forEach(sequence => {
      Object.entries(sequence).forEach(([dayNumber, timeEntry]: [any, any]) => {
        if ((timeEntry.StartTime != null && timeEntry.StartTime != '') || (timeEntry.StopTime != null && timeEntry.StopTime != '')) {
          hasTime[dayNumber] = true;
        }
      });
    });
    this.hasTime = hasTime;
  }

  private calculateSubtotalsForStandard() {
    const subTotals = [];
    for (let i = 0; i < 7; i++) {
      subTotals[i] = { Subtotal: 0, Difference: 0 };
    }
    //add subtotal amounts
    if (this.timeWorked && Array.isArray(this.timeWorked)) {
      this.timeWorked.forEach(sequence => {
        $.each(sequence, (dayNumber, timeEntry) => {
          if (timeEntry.StartTime != null && timeEntry.StartTime != '' && timeEntry.StopTime != null && timeEntry.StopTime != '') {
            const startTime = this.timeParserService.convertTimeString(timeEntry.StartTime);
            const stopTime = this.timeParserService.convertTimeString(timeEntry.StopTime);
            subTotals[dayNumber].Subtotal += stopTime - startTime;
            if (timeEntry.BreakHours != null && this.showBreakHours) {
              subTotals[dayNumber].Subtotal -= timeEntry.BreakHours || 0;
            }
          }
        });
      });
    }
    //calculate differences from timecard allocation
    this.daysOfWeek.forEach((day: any) => {
      //Round subtotal to 2 decimals
      if (subTotals[day.DayNumber].Subtotal != null) {
        subTotals[day.DayNumber].Subtotal = parseFloat(subTotals[day.DayNumber].Subtotal.toFixed(2));
      }

      //calculate difference from timecard entries
      const dateString = day.Date.getDate();
      let timecardTotal = 0;
      const breakHours = 0;
      let otherTotal = 0;

      if (!jQuery.isEmptyObject(this.timecardTotals) && this.timecardTotals[dateString] != null) {
        timecardTotal = this.timecardTotals[dateString];
      }
      if (!jQuery.isEmptyObject(this.otherTotals) && this.otherTotals[dateString] != null) {
        otherTotal = this.otherTotals[dateString];
      }

      subTotals[day.DayNumber].TimecardTotal = timecardTotal;
      subTotals[day.DayNumber].OtherTotal = otherTotal;

      if (subTotals[day.DayNumber].TimecardTotal != 0) {
        subTotals[day.DayNumber].TimecardTotal = subTotals[day.DayNumber].TimecardTotal.toFixed(2);
      }

      if (subTotals[day.DayNumber].OtherTotal != 0) {
        subTotals[day.DayNumber].OtherTotal = subTotals[day.DayNumber].OtherTotal.toFixed(2);
      }

      if (this.showBreakHours) {
        subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Subtotal - timecardTotal - otherTotal + breakHours;
      } else {
        subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Subtotal - timecardTotal - otherTotal;
      }

      subTotals[day.DayNumber].DifferenceAbs = Math.abs(subTotals[day.DayNumber].Difference.toFixed(2));

      if (subTotals[day.DayNumber].Difference != 0) {
        subTotals[day.DayNumber].Difference = subTotals[day.DayNumber].Difference.toFixed(2);
      }

      if (subTotals[day.DayNumber].Subtotal != 0) {
        subTotals[day.DayNumber].Subtotal = subTotals[day.DayNumber].Subtotal.toFixed(2);
      }

      subTotals[day.DayNumber].Text =
        '<span>Time Worked: ' +
        subTotals[day.DayNumber].Subtotal +
        '</span></br><span>Time Allocation: ' +
        subTotals[day.DayNumber].TimecardTotal +
        '</span></br></hr><span>Other Total: ' +
        subTotals[day.DayNumber].OtherTotal +
        '</span></br></hr><span>Difference: ' +
        subTotals[day.DayNumber].Difference +
        '</span>';
    });
    this.timeWorkedSubTotals = subTotals;
  }

  private calculateSubtotalsForApproval() {
    this.timeWorkedSubTotals = [];
    for (let i = 0; i < 7; i++) {
      this.timeWorkedSubTotals[i] = { Subtotal: 0, Difference: 0 };
    }
    //Add Subtotal amounts
    this.timeWorked.forEach((sequence: any) => {
      sequence.forEach((timeEntry: any, dayNumber: any) => {
        if (timeEntry.StartTime != null && timeEntry.StartTime != '' && timeEntry.StopTime != null && timeEntry.StopTime != '') {
          const startTime = this.timeParserService.convertTimeString(timeEntry.StartTime);
          const stopTime = this.timeParserService.convertTimeString(timeEntry.StopTime);
          this.timeWorkedSubTotals[dayNumber].Subtotal += stopTime - startTime - timeEntry.BreakHours;
        }
      });
    });

    //Calculate differences from timecard allocation
    this.daysOfWeek.forEach((day: any) => {
      //calculate difference from timecard entries
      const timeWorkedSubTotal = this.timeWorkedSubTotals[day.DayNumber];
      if (timeWorkedSubTotal.Subtotal != 0) {
        timeWorkedSubTotal.Subtotal = timeWorkedSubTotal.Subtotal.toFixed(2);
      }
      timeWorkedSubTotal.Text =
        '<span>Time Worked: ' +
        timeWorkedSubTotal.Subtotal +
        '</span></br><span>Time Allocation: ' +
        timeWorkedSubTotal.TimecardTotal +
        '</span></br></hr><span>Other Total: ' +
        timeWorkedSubTotal.OtherTotal +
        '</span></br></hr><span>Difference: ' +
        timeWorkedSubTotal.Difference +
        '</span>';
    });
  }

  //Modals
  getTimeWorkedDetails(day: any, timeWorkedSequence: any, isStartTime: boolean) {
    const modalRef = this.ngbModal.open(TimeWorkedDetailsModalComponent, { size: 'md', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.selectedDay = timeWorkedSequence[day.DayNumber];
    modalRef.componentInstance.isStartTime = isStartTime;
  }

  addAttachments(row: any) {
    const modalRef = this.ngbModal.open(AddTimecardAttachmentModalComponent, { size: 'md', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.row = row;
    modalRef.componentInstance.readOnly = true;
    modalRef.componentInstance.reviewModal = true;
  }

  //Called from Standard Timecard to reset the values
  resetValues() {
    this.reviewGrid = {};
    this.weeks = [];
    this.timeWorked = [];
    this.filteredPoints = [];
    this.dailyTimeData = [];
    this.daysOfWeek = [];
    this.originalTimeWorked = [];
    this.timeWorkedSubTotals = [];
    this.clearSignature();
  }

  //Button Events
  approveTimecard(timecard?: any, memo?: string) {
    this.approveTimecardEvent.emit();
  }

  rejectTimecard(timecard?: any, memo?: string) {
    if (this.isStandardTimecard) {
      this.rejectTimecardEvent.emit();
    } else {
      this.utilityService.openModal();
      if (this.timecardReview) {
        timecard = this.reviewGrid.timecard;
        memo = this.reviewGrid.memo;
      }

      const requestData = {
        prehKeyId: timecard.PREHKeyID,
        hqbcKeyId: timecard.HQBCKeyID,
        prpcKeyID: timecard.PRPCKeyID,
        memo: memo,
        submittedOnString: moment().format(this.saveDateFormat),
        crewTemplateID: null,
      };

      if (timecard.CrewTemplateID != null) requestData.crewTemplateID = timecard.CrewTemplateID;

      this.approvalService.rejectTimecard(requestData).then(
        (response: any) => {
          this.reviewGrid = {};
          this.eventService.broadcast('approvedTimecardsChanged');
          this.loadSummary.emit();
          this.utilityService.closeModal();
        },
        () => {
          this.alert = { type: 'danger', msg: 'There was an error rejecting this timecard. (' + new Date().toString('hh:mm tt') + ')' };
        }
      );
    }
  }

  cancelReview() {
    this.timecardReview = false;
    this.reviewGrid = {};
    this.reviewOnly = false;
    if (this.isStandardTimecard) {
      this.clearSignature();
    }
    this.cancel.emit();
  }

  submitClicked() {
    if (this.requireSign && this.employeeInfo.PREHKeyID == this.pREHKeyID) {
      if (this.typeSign) {
        this.submitTimecard.emit(this.rawImgData);
      } else if (!this.signaturePad.isEmpty()) {
        this.redBorder = false;
        this.submitTimecard.emit(this.signaturePad.toDataURL().replace(/^data:image\/(png|jpg);base64,/, ''));
      } else {
        this.redBorder = true;
      }
    } else {
      this.submitTimecard.emit();
    }
  }

  //Signature Pad
  clickSign(type: string) {
    if (this.signaturePad.isEmpty()) {
      this.typeSign = true;
      this.employeeService.getTypeSign(type).then((response: any) => {
        this.rawImgData = response;
        this.submitSignImg = 'data:image/png;base64,' + response;
      });
      this.hideClick = true;
      this.showClickMsg = false;
    } else {
      this.showClickMsg = true;
    }
  }

  clearSignature() {
    if (this.signaturePad != null) this.signaturePad.clear();
    this.signatureNEmpty = false;
    this.typeSign = false;
    this.rawImgData = null;
    this.submitSignImg = null;
    this.showClickMsg = false;
    this.hideClick = false;
  }

  getNotes(day: any, reviewMode = false) {
    const notes = [];
    Object.entries(this.timeWorked).forEach(([sequenceKey, sequence]) => {
      if (
        (sequence[day.DayNumber].StartTime != null && sequence[day.DayNumber].StartTime != '') ||
        (sequence[day.DayNumber].StopTime != null && sequence[day.DayNumber].StopTime != '')
      ) {
        notes.push({
          Seq: parseInt(sequenceKey) + 1,
          Note: sequence[day.DayNumber].Notes,
          DisplayValue: sequence[day.DayNumber].StartTime + ' - ' + sequence[day.DayNumber].StopTime,
        });
      }
    });
    const modalRef = this.ngbModal.open(TimeWorkedNotesModalComponent, { size: 'md', keyboard: true, backdrop: 'static' });
    modalRef.componentInstance.notes = notes;
    modalRef.componentInstance.isSubmitted = this.timecard.IsSubmitted || reviewMode;
  }
}
